import { JsonProperty, JsonObject } from 'json2typescript';
import { ModelObject } from '@hermes/api-model-core';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

let Collector = class Collector {
    constructor() {
        this.prefix = undefined;
        this.firstName = undefined;
        this.lastName = undefined;
        this.telephone = undefined;
    }
};
__decorate([
    JsonProperty("prefix"),
    __metadata("design:type", String)
], Collector.prototype, "prefix", void 0);
__decorate([
    JsonProperty("firstname"),
    __metadata("design:type", String)
], Collector.prototype, "firstName", void 0);
__decorate([
    JsonProperty("lastname"),
    __metadata("design:type", String)
], Collector.prototype, "lastName", void 0);
__decorate([
    JsonProperty("telephone"),
    __metadata("design:type", String)
], Collector.prototype, "telephone", void 0);
Collector = __decorate([
    JsonObject("Collector")
], Collector);

/**
 * Class Address used to declare a postal address for a person or a spot
 */
let Address = class Address extends ModelObject {
    constructor() {
        super(...arguments);
        this.addressId = undefined;
        this.city = undefined;
        this.district = undefined;
        this.districtLabel = undefined;
        this.districtBisId = undefined;
        this.cityBisId = undefined;
        this.collector = undefined;
        this.company = undefined;
        this.countryId = undefined;
        this.customerId = undefined;
        this.firstName = undefined;
        this.firstName2 = undefined;
        this.gender = undefined;
        this.isDefaultBilling = undefined;
        this.isDefaultShipping = undefined;
        this.isWebtoshop = undefined;
        this.lastName = undefined;
        this.lastName2 = undefined;
        this.postcode = undefined;
        // @deprecated : use postcodeBis instead
        this.postCodeBis = undefined;
        this.postcodeBis = undefined;
        this.prefix = undefined;
        this.region = undefined;
        this.regionLabel = undefined;
        this.shopId = undefined;
        this.streetNumber = undefined;
        this.street1 = undefined;
        this.street2 = undefined;
        this.street3 = undefined;
        this.middlename = undefined;
        this.suffix = undefined;
        this.telephone = undefined;
        this.telephone2 = undefined;
        this.type = undefined;
        this.vatId = undefined;
        this.addressVerification = undefined;
        this.isApplePay = undefined;
        this.isFirstApplePayAdress = undefined;
        this.additionalNumber = undefined;
        this.neighborhood = undefined;
        this.applePayEmail = undefined;
    }
};
__decorate([
    JsonProperty("address_id", String, true),
    __metadata("design:type", String)
], Address.prototype, "addressId", void 0);
__decorate([
    JsonProperty("city", String, true),
    __metadata("design:type", String)
], Address.prototype, "city", void 0);
__decorate([
    JsonProperty("district", String, true),
    __metadata("design:type", String)
], Address.prototype, "district", void 0);
__decorate([
    JsonProperty("district_label", String, true),
    __metadata("design:type", String)
], Address.prototype, "districtLabel", void 0);
__decorate([
    JsonProperty("district_bis_id", String, true),
    __metadata("design:type", String)
], Address.prototype, "districtBisId", void 0);
__decorate([
    JsonProperty("city_bis_id", String, true),
    __metadata("design:type", String)
], Address.prototype, "cityBisId", void 0);
__decorate([
    JsonProperty("collector", Collector, true),
    __metadata("design:type", Collector)
], Address.prototype, "collector", void 0);
__decorate([
    JsonProperty("company", String, true),
    __metadata("design:type", String)
], Address.prototype, "company", void 0);
__decorate([
    JsonProperty("country_id", String, true),
    __metadata("design:type", String)
], Address.prototype, "countryId", void 0);
__decorate([
    JsonProperty("customer_id", String, true),
    __metadata("design:type", String)
], Address.prototype, "customerId", void 0);
__decorate([
    JsonProperty("firstname", String, true),
    __metadata("design:type", String)
], Address.prototype, "firstName", void 0);
__decorate([
    JsonProperty("firstname2", String, true),
    __metadata("design:type", String)
], Address.prototype, "firstName2", void 0);
__decorate([
    JsonProperty("gender", String, true),
    __metadata("design:type", String)
], Address.prototype, "gender", void 0);
__decorate([
    JsonProperty("is_default_billing", Boolean, true),
    __metadata("design:type", Boolean)
], Address.prototype, "isDefaultBilling", void 0);
__decorate([
    JsonProperty("is_default_shipping", Boolean, true),
    __metadata("design:type", Boolean)
], Address.prototype, "isDefaultShipping", void 0);
__decorate([
    JsonProperty("is_webtoshop", Boolean, true),
    __metadata("design:type", Boolean)
], Address.prototype, "isWebtoshop", void 0);
__decorate([
    JsonProperty("lastname", String, true),
    __metadata("design:type", String)
], Address.prototype, "lastName", void 0);
__decorate([
    JsonProperty("lastname2", String, true),
    __metadata("design:type", String)
], Address.prototype, "lastName2", void 0);
__decorate([
    JsonProperty("postcode", String, true),
    __metadata("design:type", String)
], Address.prototype, "postcode", void 0);
__decorate([
    JsonProperty("postcode_bis", String, true),
    __metadata("design:type", String)
], Address.prototype, "postCodeBis", void 0);
__decorate([
    JsonProperty("postcode_bis", String, true),
    __metadata("design:type", String)
], Address.prototype, "postcodeBis", void 0);
__decorate([
    JsonProperty("prefix", String, true),
    __metadata("design:type", String)
], Address.prototype, "prefix", void 0);
__decorate([
    JsonProperty("region", String, true),
    __metadata("design:type", String)
], Address.prototype, "region", void 0);
__decorate([
    JsonProperty("region_label", String, true),
    __metadata("design:type", String)
], Address.prototype, "regionLabel", void 0);
__decorate([
    JsonProperty("shop_id", String, true),
    __metadata("design:type", String)
], Address.prototype, "shopId", void 0);
__decorate([
    JsonProperty("street_number", String, true),
    __metadata("design:type", String)
], Address.prototype, "streetNumber", void 0);
__decorate([
    JsonProperty("street1", String, true),
    __metadata("design:type", String)
], Address.prototype, "street1", void 0);
__decorate([
    JsonProperty("street2", String, true),
    __metadata("design:type", String)
], Address.prototype, "street2", void 0);
__decorate([
    JsonProperty("street3", String, true),
    __metadata("design:type", String)
], Address.prototype, "street3", void 0);
__decorate([
    JsonProperty("middlename", String, true),
    __metadata("design:type", String)
], Address.prototype, "middlename", void 0);
__decorate([
    JsonProperty("suffix", String, true),
    __metadata("design:type", String)
], Address.prototype, "suffix", void 0);
__decorate([
    JsonProperty("telephone", String, true),
    __metadata("design:type", String)
], Address.prototype, "telephone", void 0);
__decorate([
    JsonProperty("telephone2", String, true),
    __metadata("design:type", String)
], Address.prototype, "telephone2", void 0);
__decorate([
    JsonProperty("type", String, true),
    __metadata("design:type", String)
], Address.prototype, "type", void 0);
__decorate([
    JsonProperty("vat_id", String, true),
    __metadata("design:type", String)
], Address.prototype, "vatId", void 0);
__decorate([
    JsonProperty("address_verification", Number, true),
    __metadata("design:type", Number)
], Address.prototype, "addressVerification", void 0);
__decorate([
    JsonProperty("is_apple_pay", Boolean, true),
    __metadata("design:type", Boolean)
], Address.prototype, "isApplePay", void 0);
__decorate([
    JsonProperty("is_first_apple_pay_address", Boolean, true),
    __metadata("design:type", Boolean)
], Address.prototype, "isFirstApplePayAdress", void 0);
__decorate([
    JsonProperty("additional_number", String, true),
    __metadata("design:type", String)
], Address.prototype, "additionalNumber", void 0);
__decorate([
    JsonProperty("neighborhood", String, true),
    __metadata("design:type", String)
], Address.prototype, "neighborhood", void 0);
__decorate([
    JsonProperty("apple_pay_email", String, true),
    __metadata("design:type", String)
], Address.prototype, "applePayEmail", void 0);
Address = __decorate([
    JsonObject("Address")
], Address);
const ADDRESS_TYPE_ENUM = {
    BILLING: "billing",
    SHIPPING: "shipping",
    BOTH: "both",
};

export { ADDRESS_TYPE_ENUM, Address, Collector };
